const io = require('socket.io-client');
const feathers = require('@feathersjs/client');
const socketio = require('@feathersjs/socketio-client');

import localstorage from "feathers-localstorage";
import auth from "@feathersjs/authentication-client";
const storage = process.env.VUE_ENV === "server" ? null : window.localStorage; // allows for server side rendering?

import { actions } from "Js/actionsProcessor";

import store from "Js/store";

const app = feathers();

const socket = io({
  transports: ["websocket"]
});

app.configure(socketio(socket, {
  timeout: 20000
}));

  // AUTHENTICATION
app.configure(
    feathers.authentication({
      header: "Authorization", // the default authorization header for REST
      path: "/authentication", // the server-side authentication service path
      jwtStrategy: "jwt", // the name of the JWT authentication strategy
      entity: "user", // the entity you are authenticating (ie. a users)
      service: "users", // the service to look up the entity
      idField: "id",
      //TODO change to BF name vs feathers
      cookie: "feathers-jwt", // the name of the cookie to parse the JWT from when cookies are enabled server side
      storageKey: "feathers-jwt", // the key to store the accessToken in localstorage or AsyncStorage on React Native
      storage: window.localStorage, // Passing a WebStorage-compatible object to enable automatic storage on the client.
      timeout: 20000
    })
  );

socket.on("reconnect", () => {
  console.log("socket reconnected");
  app.reAuthenticate();
});

export { app };

app.service("script").timeout = 20000;
app.service("form").timeout = 20000;
app.service("user").timeout = 20000;
app.service("authentication").timeout = 20000;

app.service("messages")
  .on('created', message => {
    
    store.dispatch('UPDATE_MODEL', {
        model:message.model, 
        ind: message.modelIndex || 0 
    } );
    store.commit('SET_APP', message.app);
    
    store.dispatch("ACTIONS_QUEUE", message.actions);
  });
  
app.service("message/sendmessage")
  .on('created', message => {
    
    store.dispatch('UPDATE_MODEL', {
        model:message.model, 
        ind: message.modelIndex || 0 
    } );
    store.commit('SET_APP', message.app);
    
    store.dispatch("ACTIONS_QUEUE", message.actions);
  });

// SURFACE SERVICES
export { socket };
export const userService = app.service("users");
export const logService = app.service("logs");
export const formService = app.service("forms");
export const siteService = app.service("sites");
export const scriptService = app.service("script");
export const messageService = app.service("messages");
export const messageAddUserService = app.service("message/adduser");
export const messageRemoveUserService = app.service("message/removeuser");
